import fetch from '@/utils/fetch';
import { message } from 'antd';
import { AUDIT_STATUS_MAP } from '../config';
import { getCityList as getCityData } from '@/apis/commonApi';

const model = {
  state: {
    chiefList: [], // 团长列表
    cityList: [], // 城市列表
    filterState: {
      pageNum: 1,
      pageSize: 30,
      auditStatus: 0,
      cityCode: 0,
    }, // 团长列表过滤参数
    chiefTotal: 0, // 团长列表总数
    currentChief: {}, // 当前操作的团长
    logList: [], // 操作日志列表
    logFilter: {
      pageNum: 1,
      pageSize: 10,
    },
    logListTotal: 0,
    groupFilter: {
      pageNum: 1,
      pageSize: 10,
    },
    groupListTotal: 0,
    orderFilter: {
      pageNum: 1,
      pageSize: 10,
    },
    orderListTotal: 0,
    // 商圈列表
    bdList: [],
    roleList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { ChiefList, basic }, getState }) => ({
    async getChiefList(param) {
      const params = getState().ChiefList.filterState;
      params.cityCode = params.cityCode || undefined;
      params.auditStatus = params.auditStatus || undefined;
      const resData = await fetch('/saasmerchant/web/customergroup/master/list', {
        params: {
          ...params,
          ...param,
        },
      });
      const { list, total } = resData || {};
      ChiefList.setState({
        chiefList: list || [],
        chiefTotal: total || [],
      });
      return list;
    },
    async getCityList() {
      const data = getState().basic?.cityData || (await getCityData()) || [];
      const cityList = [
        {
          key: 0,
          content: '全部',
        },
      ];
      data &&
        data.forEach((province) => {
          province.children.forEach((city) => {
            cityList.push({
              key: city.value,
              content: city.label,
            });
          });
        });
      ChiefList.setState({
        cityList,
      });
    },
    setCurrentChief(chief) {
      ChiefList.setState({
        currentChief: chief,
      });
    },
    setFilter(params) {
      ChiefList.setState({ filterState: { ...getState().ChiefList.filterState, ...params } });
    },
    async audit(params) {
      const data = await fetch('/saasmerchant/web/customergroup/master/audit', {
        params,
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success(params.auditStatus === AUDIT_STATUS_MAP.PASS ? '审核通过' : '已拒绝');
        // ChiefList.setFilter({ pageNum: 1 });
      }
      return data;
    },
    async getMasterLogList(params = {}) {
      const resData = await fetch('/saasmerchant/web/customergroup/master/operateLog', {
        params,
      });
      const { list, total } = resData || {};
      ChiefList.setState({
        logList: list || [],
        logListTotal: total || 0,
      });
    },
    setLogFilter(params = {}) {
      ChiefList.setState({ logFilter: { ...getState().ChiefList.logFilter, ...params } });
    },
    async getGroupList(params) {
      const newSearchParams = { ...getState().ChiefList.groupFilter, ...params };
      const resData = await fetch('/saasmerchant/web/customergroup/master/groupList', {
        params: newSearchParams,
      });
      const { list, total } = resData || {};
      ChiefList.setState({
        groupList: list || [],
        groupListTotal: total || 0,
        groupFilter: newSearchParams,
      });
    },
    async getOrderList(params = {}) {
      const newSearchParams = { ...getState().ChiefList.orderFilter, ...params };
      const resData = await fetch('/saasmerchant/web/customergroup/master/orderList', {
        params: newSearchParams,
      });
      const { data, total } = resData || {};
      ChiefList.setState({
        orderList: data || [],
        orderListTotal: total || [],
        orderFilter: newSearchParams,
      });
    },
    changeChiefStatus(params) {
      return fetch('/saasmerchant/web/customergroup/master/disable', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    getChiefDetailData(masterId) {
      return fetch('/saasmerchant/web/customergroup/master/detail', { params: { masterId } });
    },
    updateBenefitFlag(params) {
      return fetch('/saasmerchant/web/customergroup/master/updateBenefitFlag', { params });
    },
    async updateChiefInfo(params) {
      const data = await fetch('/saasmerchant/web/customergroup/master/update', {
        params,
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('修改成功');
      }
      return data;
    },
    // 获取商圈列表
    async getBDList(params) {
      const bdList = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByName',
        {
          params,
        },
      );
      ChiefList.setState({ bdList: bdList || [] });
      return bdList;
    },
    clearBDList() {
      ChiefList.setState({ bdList: [] });
    },
    async getRoleList() {
      const data = await fetch('/saasmerchant/web/customergroup/master/queryMasterRoles');
      ChiefList.setState({ roleList: data });
    },
  }),
};

export default model;
